/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse, 
  HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

import { TicketCounters } from '../models';

@Injectable()
export class ManagerTicketCountersService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   */
  managerTicketCountersResponse(params: ManagerTicketCountersService.ManagerTicketCountersParams): Observable<HttpResponse<TicketCounters[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.page != null) __params = __params.set("page", params.page.toString());
    if (params.limit != null) __params = __params.set("limit", params.limit.toString());
    if (params.page != null) __params = __params.set("key_input", params.key_input.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/ticket-counters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketCounters[] = null;
        _body = _resp.body as TicketCounters[]
        return _resp.clone({body: _body}) as HttpResponse<TicketCounters[]>;
      })
    );
  }
  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   * @param disable - The numbers of items to return.
   */
  managerTicketCounters(params: ManagerTicketCountersService.ManagerTicketCountersParams): Observable<TicketCounters[]> {
    return this.managerTicketCountersResponse(params).pipe(
      map(_r => _r.body)
    );
  }
  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   */

  managerCreateTicketCountersResponse(body?: TicketCounters): Observable<HttpResponse<TicketCounters>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/ticket-counters`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketCounters = null;
        _body = _resp.body as TicketCounters
        return _resp.clone({body: _body}) as HttpResponse<TicketCounters>;
      })
    );
  }

  /**
   * @param body - Created User object
   */
  managerCreateTicketCounters(body?: TicketCounters): Observable<TicketCounters> {
    return this.managerCreateTicketCountersResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerUpdateTicketCountersResponse(body?: TicketCounters): Observable<HttpResponse<TicketCounters>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/ticket-counters/${body.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: TicketCounters = null;
        _body = _resp.body as TicketCounters
        return _resp.clone({body: _body}) as HttpResponse<TicketCounters>;
      })
    );
  }

  /**
   * @param body - update
   */
  managerUpdateTicketCounters(body?: TicketCounters): Observable<TicketCounters> {
    return this.managerUpdateTicketCountersResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerDeleteTicketCountersResponse(id: number): Observable<HttpResponse<void>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    
    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/manager/ticket-counters/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: void = null;
        
        return _resp.clone({body: _body}) as HttpResponse<void>;
      })
    );
  }

  /**
   * @param userId - undefined
   */
  managerDeleteTicketCounters(id: number): Observable<void> {
    return this.managerDeleteTicketCountersResponse(id).pipe(
      map(_r => _r.body)
    );
  }
}

export module ManagerTicketCountersService {
  export interface ManagerTicketCountersParams {
    page?: number;
    limit?: number;
    key_input?: string;
  }
}
